<div class="w-full  text-white flex  items-center app-header px-5 justify-between h-[8vh] z-100 relative">

    <div>
        <img src="assets/logo.png" alt="logo" class="h-[5vh]" />
    </div>

    <div class="flex items-center gap-5">

        <div *ngIf="campusList.length >= 2">
            <p-select [options]="campusList" [loading]="campusList.length === 0" class="location-select"
                [(ngModel)]="selectedCampus" optionLabel="name" optionValue="campus_id"
                (onChange)="onCampusChange($event)" placeholder="Select a Campus" />
        </div>

        <div class="hidden sm:flex icon-container">
            <div>
                <i class="pi pi-bell cursor-pointer" pBadge value="0" (click)="op.toggle($event)"></i>
            </div>

            <!-- <div>
                <i class="pi pi-envelope"></i>
            </div>

            <div>
                <i class="pi pi-user"></i>
            </div> -->

        </div>

        <div class="flex items-center gap-1 ">
            <div class="hidden md:flex">
                {{userProfileName}}
            </div>
            <div style="background-color: #fff;"
                class="flex items-center justify-center  h-12 w-12 rounded-full ml-0 sm:ml-5 cursor-pointer">
                
                <div *ngIf="profilePicture === '' || profilePicture == null || profilePicture === undefined || studentProfileMode">
                    <p-avatar label="{{getInitials()}}" shape="circle" class="h-4 w-4" (click)="menu.toggle($event)" />
                </div>

                <div *ngIf="profilePicture != '' && profilePicture != null && profilePicture != 'null' && !studentProfileMode" class="flex justify-center">
                    <img [src]="profilePicture" shape="circle"
                    class="h-10 w-10 object-cover object-top rounded-full" (click)="menu.toggle($event)" />
                </div>

              

                <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
            </div>
        </div>


        <div class="notification-popover">
            <p-popover #op [style]="myStyle">
                <div class="flex flex-col gap-4 w-[28rem] p-3">
                    <div>
                        <span class="font-medium text-surface-900 dark:text-surface-0 block mb-1">Notifcations</span>
                    </div>
                    <div>
                            <div 
                            class="flex justify-center items-center font-bold text-[15px] mb-6 mt-4"
                            > 
                                No notifications available
                            </div>
                        <!-- <ul class="list-none p-0 m-0 flex flex-col gap-4 max-h-[50vh] overflow-y-auto scrollbar-hide">
                            <li *ngFor="let member of members" class="flex items-center gap-2">
                                <img [src]="'https://primefaces.org/cdn/primeng/images/demo/avatar/' + member.image"
                                    style="width: 32px" />
                                <div>
                                    <span class="font-bold">{{ member.title }}</span>
                                    <div class="text-sm">{{ member.desc }}</div>
                                </div>
                                <div class="flex items-center text-muted-color ml-auto text-[10px]">
                                    <span>{{ member.time }}</span>
                                </div>
                            </li>
                        </ul> -->
                    </div>
                </div>
            </p-popover>
        </div>

    </div>




</div>


<p-dialog [modal]="true" [(visible)]="showProfile" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '60vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="showProfile">
    <app-user-profile (closeDialog)="handleCloseProfile()"></app-user-profile>
    </ng-container>
</p-dialog>

<!-- <app-floating-configurator /> -->
<p-toast />